<template>
  <img
    v-if="lazyImageDisable"
    class="lazyload"
    :alt="alt"
    :data-srcset="srcset"
    :data-src="fallbackurl"
    :data-sizes="sizes"
    :data-aspectration="ratio"
  />
  <img v-else :alt="alt" :srcset="srcset" :src="fallbackurl" :sizes="sizes" />
</template>

<script>
// resolutions: [{width: 250, hash: ''}, {width: 300, hash: ''}, {width: 400, hash: ''}]
// fallback-size: {width: 150, hash: ''}

export default {
  name: 'media-searchimage',
  props: {
    filename: { type: String, required: true },
    alt: { type: String, default: '' },
    resolutions: { type: Array, required: true },
    lazy: { type: Boolean, default: false },
    sizes: { type: String, default: '100vw', required: false },
    fallbackSize: { type: Object, required: true },
    ratio: { type: String, default: '', required: false },
  },
  data() {
    return {
      lazyImageDisable: this.lazy || false,
    };
  },
  computed: {
    srcset() {
      let srcset = '';

      this.resolutions.forEach((resolution) => {
        srcset += `${this.getUrl(resolution.width, resolution.hash)} ${resolution.width}w,`;
      });

      srcset = srcset.slice(0, -1);
      return srcset;
    },
    fallbackurl() {
      return this.getUrl(this.fallbackSize.width, this.fallbackSize.hash);
    },
  },
  created() {
    window.eventBus.$on('lazy-image-disable', () => {
      this.lazyImageDisable = false;
    });
  },
  methods: {
    getUrl(width, hash) {
      return `${this.filename}?as=1&w=${width}&hash=${hash}`;
    },
  },
};
</script>
